import { render, staticRenderFns } from "./CounterList.vue?vue&type=template&id=1bcd3519&scoped=true&"
import script from "./CounterList.vue?vue&type=script&lang=js&"
export * from "./CounterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcd3519",
  null
  
)

export default component.exports